/* eslint-disable */

export function initializeTracking() {
    !function (w, d) {
        if (!w.rdt) {
            var p = w.rdt = function () {
                p.sendEvent ? p.sendEvent.apply(p, arguments) : p.callQueue.push(arguments)
            };
            p.callQueue = [];
            var t = d.createElement("script");
            t.src = "https://www.redditstatic.com/ads/pixel.js", t.async = !0;
            var s = d.getElementsByTagName("script")[0];
            s.parentNode.insertBefore(t, s)
        }
    }(window, document);
    rdt('init', 't2_9w1jesl1');
    rdt('track', 'PageVisit');
    const script = document.createElement('script')
    script.src = 'https://www.googletagmanager.com/gtag/js?id=G-VKER7XQK2R'
    document.head.append(script);
    window.dataLayer = window.dataLayer || [];

    function gtag() {
        dataLayer.push(arguments);
    }

    window.gtag = gtag;
    window.gtag('js', new Date());
    window.gtag('config', 'G-VKER7XQK2R');
}

export function trackRegister() {
    try {
        window.gtag('event', 'Lead', 1);
    } catch (ex) {
        console.log('error in tracking', ex);
    }

    try {
        plausible('Registration');
    } catch (ex) {
        console.log('error in tracking', ex);
    }
}
